import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import { executeQueryDto } from 'src/app/tabms/models/tab-administration/execute-query';

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  //#region communications between components
  searchValueChange = new Subject<string>();

  exportOptionsChange = new Subject<string>();

  createFormDisplay = new BehaviorSubject<{ show: boolean; id: any }>(null);

  clearForm = new Subject<boolean>();

  saveForm = new Subject<boolean>();
  
  // Flag used by Save & Copy flow to keep the form open after successful add
  keepFormOpenOnSave = new Subject<boolean>();

  refreshTable = new Subject<boolean>();

  applyCriteria = new Subject<Object>();

  applyFilter = new Subject<string>();

  saveRetrieveLocalData = new Subject<number>(); //saveorRetrieve = 1 for saving in local storage, saveorRetrieve = 2 for retrieving from local storage,
  //saveorRetrieve = 0 no action

  addRemoveFavourite = new Subject<number>(); //addRemove = 1 for for adding to favourite and 2 for removing from favourite

  uploadedData = new Subject<object>();

  pageToolsDynamicMenuChange = new Subject<string>();

  showReport = new Subject<{}>();

  designReport = new Subject<{}>();
  // saveAndDesgin = new Subject<{}>();
  saveAndDesgin = new Subject<boolean>();
  sendEditId = new Subject<string>();

  clearPageSelectedOption = new Subject<boolean>();

  uploadfromExcel = new Subject<object>();

  // phoneReset: Subject<boolean> = new ReplaySubject<boolean>();

  formInitialized: Subject<boolean> = new ReplaySubject<boolean>();

  formBuild: Subject<FormGroup> = new ReplaySubject<FormGroup>();

  transferItems: Subject<{}> = new ReplaySubject<{}>();

  headerIdExist: Subject<string> = new ReplaySubject<string>();

  saveFromGrid: Subject<boolean> = new ReplaySubject<boolean>();

  showAddEdit = new BehaviorSubject<{ show: boolean; id: string; type: number }>({ show: false, id: null, type: null });

  selectedId = new BehaviorSubject<string>(null);

  deleteDef: Subject<string> = new ReplaySubject<string>()

  gridData: Subject<any[]> = new BehaviorSubject<any[]>([]);

  detailsGridData: Subject<any[] | {[key: string]: [value: any]}> = new Subject<any[] | {[key: string]: [value: any]}>();

  printListFields: Subject<any> = new ReplaySubject<any>();

  editForm: Subject<any> = new ReplaySubject<any>();

  observableId: Subject<{ id: string }> = new ReplaySubject<{ id: string }>(null);

  addTableFields: Subject<boolean> = new Subject<boolean>()

  showGridList: Subject<boolean> = new Subject<boolean>()

  copyFieldDicList: Subject<boolean> = new Subject<boolean>();

  autoTranslate: Subject<boolean> = new Subject<boolean>();

  addImage: Subject<{ formKey: string, id: any }> = new Subject<{ formKey: string, id: any }>();

  trxDateChange: Subject<string> = new ReplaySubject<string>();

  createQueryLog: Subject<{ id: string, executionResult: executeQueryDto }> = new Subject<{ id: string, executionResult: executeQueryDto }>();

  approved: Subject<boolean> = new Subject<boolean>();
  
  rejected: Subject<boolean> = new Subject<boolean>();

  customSaveStrategy: Subject<any> = new Subject<any>();

  createBulkDataF: Subject<any[]> = new Subject<any[]>();

  updateDone: Subject<any> = new Subject<any>();

  // beforeSaveWork: Subject<boolean> = new ReplaySubject<boolean>();
// emitImage(formKey: string, id: string) {
//   console.log('Emitting addImage:', { formKey, id });
//   this.addImage.next({ formKey, id });
// }

  //#endregion

  constructor(
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }

  //#region toast methods
  showSuccessMessage(message, title = 'success') {
    this.toastr.success(
      this.translate.instant(message),
      this.translate.instant(title),
      {
        toastClass: 'ngx-toastr custom-toast-single-line'
      }
    );
  }

  showErrorMessage(message) {
    this.toastr.error(this.translate.instant(message), this.translate.instant('error'), {
      timeOut: 8000,
      extendedTimeOut: 5000,
      closeButton: true,
      progressBar: true
    });
  }

  showInfoMessage(message) {
    this.toastr.info(this.translate.instant(message), this.translate.instant('info'));
  }

  showWarningMessage(message) {
    this.toastr.warning(this.translate.instant(message), this.translate.instant('warning'));
  }
  //#endregion

  getCurrentLanguage() {
    let currentLang = localStorage.getItem('language') ? localStorage.getItem('language') : 'ar';
    return currentLang;
  }

  getDirection() {
    return 'ar' === this.getCurrentLanguage() ? 'rtl' : 'ltr';
  }
}
